<template>
    <div>
        <div class="backfround">
            <img :src="loginConfig.userViewLoginBackground" alt="">
        </div>
        <div class="logo">
            <img :src="loginConfig.logo" alt="logo">
        </div>
        <div class="opreation">
            <p>手机号</p>
            <mt-field placeholder="请输入手机号" type="tel" v-model="userName"></mt-field>
            <span v-if="showError" class="error">请输入有效的电话号码！</span>
            <p>验证码</p>
            <div class='flex'>
                <mt-field placeholder="请输入验证码"  type="text" v-model="password"></mt-field>
                <mt-button :disabled="getLoginCode" class="get" @click="getCode()">{{
                getLoginCode ? this.time : '获取验证码'
                }}{{ getLoginCode ? 's' : '' }}</mt-button>
            </div>
            <span v-if="showPasswordError" class="error">验证码错误！</span>
            <mt-button class="save" @click="login()">登录</mt-button>
            <div class="mottoTitle">
                <p>or</p>
            </div>
            <div class="line"></div>
            <p class="bottom" @click="loginWithAccount">密码登录</p>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import UserFetch from '../../fetch/user';
import { Toast } from 'mint-ui';
import Auth from '../../utils/auth';

export default {
  name: 'LoginCode',
  meta:{page:true},
  watch: {
      getLoginCode: function(value) {
          console.log(value);
          if (value) this.runtime()
          if (!value) window.clearInterval(this.intervel);
      },
      errorMessage: function(val) {
        if (val !== '') {
            Toast({
                message: val,
                className: 'errorMessage'
            });
        }
    },
    successMessage: function(val) {
        if (val !== '') Toast(val);
    },
  },
  computed: {
        ...mapGetters('user', {
            loginConfig: 'getLoginConfig',
            getLoginCode: 'getLoginCode',
            errorMessage: 'getErrorMessage',
            successMessage: 'getSuccessMessage'
        })
  },
  data() {
    return {
        userName: '',
        password: '',
        showError: false,
        showPasswordError: false,
        intervel: null,
        time: 60,
    }
  },
  created() {
      this.checkLogin();
     // this.$store.dispatch('user/loginInit');
      this.$store.dispatch('user/initLoginCode');
  },
  beforeDestroy() {
      window.clearInterval(this.intervel);
  },
  methods: {
      checkLogin:function(){
          if(Auth.loginUser()){
              let refer = this.$route.query.refer||'/';
              this.$router.replace({path:refer});
          }
      },

      loginWithAccount: function() {
        let refer = this.$route.query.refer||'/';
          this.$router.replace({'name':'loginPasswd',query:{refer}});
      },
      runtime: function() {
          const self = this;
          window.clearInterval(this.intervel);
          this.intervel = window.setInterval(function() {
              self.time = self.time - 1;
              if (self.time <= 0) {
                  self.$store.dispatch('user/initLoginCode');
                  window.clearInterval(self.intervel);
                  self.time = 60;
              }
          }, 1000)
      },
      getCode: function() {
          const reg=/^[1][3,4,5,7,8][0-9]{9}$/;
          if (!reg.test(this.userName)) {
              this.showError = true;
              return;
          } else {
              this.showError = false;
          }
          this.$store.dispatch('user/getLoginCode', { phone: this.userName })
      },
      login: function() {
        // if (!this.getLoginCode) return;
        const reg=/^[1][3,4,5,7,8][0-9]{9}$/;
        if (!reg.test(this.userName)) {
            this.showError = true;
            return;
        } else {
            this.showError = false;
        }
        if (this.password.trim() === '') {
            this.showPasswordError = true;
            return;
        } else {
            this.showPasswordError = false;
        }
        let refer = this.$route.query.refer||'/';
        this.$store.dispatch('user/loginWithCode', { phone: this.userName, code: this.password ,refer:refer})
      }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"  scoped>
  @import "../../assets/scss/login.scss";
.forget {
    font-size: .13rem;
}

.save {
    margin-top: 12px;
}
.get {
    font-size: .1rem;
    /*width: 100%;*/
    width: 1.3rem;
    background: #ffffff;
    color: #009688;
    border: 1px solid #009688;
    height: 48px;
    margin-left: 8px;
}

.mottoTitle p {
    color: #7f7f7f;
}
.line {
    height: 1px;
    background: #7f7f7f;
    margin-top: -.17rem;
}
.bottom {
    color: #009688;
}
</style>




// WEBPACK FOOTER //
// src/components/page/LoginCode.vue